import request from '@/utils/request'

// 优惠券为平台级模块：券模板只维护 sh_id=1 一份，仅平台管理员可增删改
export const SH_ID = 1

const BASE = '/coupon/coupon_main.php'

/**
 * 3.1 券模板列表
 * @param {Object} params { keyword, type, display, page, page_size }
 */
export const templateLists = (params = {}) => {
  return request.post(`${BASE}?a=lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.2 新增券模板（只能新增活动券，新人专享券由系统内置）
 * @param {Object} params { name, amount, min_amount, scope, scope_ids, valid_type, valid_days, start_time, end_time, per_limit, total_limit, display, sort, remark }
 */
export const templateAdd = (params = {}) => {
  return request.post(`${BASE}?a=add`, { sh_id: SH_ID, ...params })
}

/**
 * 3.3 编辑券模板（只传需要变更的字段）
 * @param {Object} params { id, ...fields }
 */
export const templateEdit = (params = {}) => {
  return request.post(`${BASE}?a=edit`, { sh_id: SH_ID, ...params })
}

/**
 * 3.4 删除券模板（已发放过的模板后端会自动改为停用）
 * @param {Object} params { id }
 */
export const templateDel = (params = {}) => {
  return request.post(`${BASE}?a=del`, { sh_id: SH_ID, ...params })
}

/**
 * 3.5 初始化 / 查看新人专享券模板
 */
export const templateInit = (params = {}) => {
  return request.post(`${BASE}?a=template_init`, { sh_id: SH_ID, ...params })
}

/**
 * 3.6 券实例列表
 * @param {Object} params { crm_id, template_id, status, source, keyword, start_time, end_time, page, page_size }
 */
export const couponLists = (params = {}) => {
  return request.post(`${BASE}?a=coupon_lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.7 券实例详情（附带全部流水）
 * @param {Object} params { id }
 */
export const couponDetail = (params = {}) => {
  return request.post(`${BASE}?a=coupon_detail`, { sh_id: SH_ID, ...params })
}

/**
 * 3.8 券流水（平台级）
 * @param {Object} params { coupon_id, crm_id, action, order_dh, page, page_size }
 */
export const couponFlow = (params = {}) => {
  return request.post(`${BASE}?a=coupon_flow`, { sh_id: SH_ID, ...params })
}

/**
 * 3.9 作废券（仅未使用/已锁定可作废，原因必填）
 * @param {Object} params { id, reason }
 */
export const couponInvalid = (params = {}) => {
  return request.post(`${BASE}?a=coupon_invalid`, { sh_id: SH_ID, ...params })
}

/**
 * 3.10 会员筛选（批量发券第 1 步）
 * @param {Object} params { keyword, start_time, end_time, min_money, max_money, rank, group, crm_ids, page, page_size }
 */
export const memberLists = (params = {}) => {
  return request.post(`${BASE}?a=member_lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.11 批量发券预览（第 2 步）
 * @param {Object} params { crm_ids, template_ids }
 */
export const sendPreview = (params = {}) => {
  return request.post(`${BASE}?a=send_preview`, { sh_id: SH_ID, ...params })
}

/**
 * 3.12 批量发券执行（第 3 步）
 * @param {Object} params { crm_ids, template_ids, member_scope, remark }
 */
export const sendBatch = (params = {}) => {
  return request.post(`${BASE}?a=send_batch`, { sh_id: SH_ID, ...params })
}

/**
 * 3.13 发券任务列表（审计）
 * @param {Object} params { operator, start_time, end_time, status, page, page_size }
 */
export const sendLogs = (params = {}) => {
  return request.post(`${BASE}?a=send_logs`, { sh_id: SH_ID, ...params })
}

/**
 * 3.14 发券任务明细（可导出）
 * @param {Object} params { batch_id, status, page, page_size }
 */
export const sendLogDetail = (params = {}) => {
  return request.post(`${BASE}?a=send_log_detail`, { sh_id: SH_ID, ...params })
}

/**
 * 3.15 优惠券统计
 * @param {Object} params { start_time, end_time }
 */
export const couponStat = (params = {}) => {
  return request.post(`${BASE}?a=coupon_stat`, { sh_id: SH_ID, ...params })
}
